var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page"},[_vm._l((_vm.sections),function(section,index){return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('section',{class:'section',attrs:{"id":section.type}},_vm._l((section.childs),function(child,index){return _c(child.type,{key:child.type,tag:"component",attrs:{"content":child}})}))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed444bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 7IiW
// module chunks = 1